module.exports = __webpack_public_path__ + "static/media/key.8cccb806.mov";